import script from "./OverspeedTemplateTables.vue?vue&type=script&setup=true&lang=js"
export * from "./OverspeedTemplateTables.vue?vue&type=script&setup=true&lang=js"

import "./OverspeedTemplateTables.vue?vue&type=style&index=0&id=277a851a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-277a851a"]])

export default __exports__